module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header",
    staticStyle: {
      "display": "none"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top navbar2",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-10 col-md-offset-2",
    staticStyle: {
      "margin-top": "-60px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-left col-md-8 col-md-offset-2"
  }, [_c('ul', {
    staticClass: "indexSteps"
  }, [_c('li', {
    staticClass: "indexStepLi"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexProduct))]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexNews))]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexResource))]), _vm._v(" "), _c('ul', {
    staticClass: "resourceSteps dropdown-menu w100",
    attrs: {
      "role": "menu",
      "aria-labelledby": "dLabel"
    }
  }, [_c('li', {
    staticClass: "resourceStepLi"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexDoc) + "\n                                        ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_c('a', {
    attrs: {
      "href": _vm.forumUrl,
      "target": "_new"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexForum) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right col-md-2 navbar-custom-menu",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100px",
      "min-width": "80px"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('zh-TW')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right"
  }, [(_vm.$root.$i18n.locale === 'zh-TW') ? _c('i', {
    staticClass: "fa fa-check label-success"
  }) : _vm._e()]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('en')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right"
  }, [(_vm.$root.$i18n.locale === 'en') ? _c('i', {
    staticClass: "fa fa-check label-success"
  }) : _vm._e()]), _vm._v(" "), _vm._m(3)])])])])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.email),
      expression: "!email"
    }],
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_index_login()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexLogin) + "\n                                ")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.email),
      expression: "!email"
    }],
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_index_register()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexRegister) + "\n                                ")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "dropdown notifications-menu"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "min-width": "180px",
      "width": "180px"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'listApp'
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('i', {
    staticClass: "fa fa-cog text-aqua"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-center"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t('indexControlPanel')) + "\n                                                        ")])])])], 1), _vm._v(" "), _c('li', [(_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('i', {
    staticClass: "fa fa-sign-out text-yellow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-center"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t('logout')) + "\n                                                        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'userLogout'
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('i', {
    staticClass: "fa fa-sign-out text-yellow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-center"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t('logout')) + "\n                                                        ")])])]) : _vm._e()], 1)])])])])])])])])])]), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "900px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer",
    staticStyle: {
      "display": "none"
    }
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n            "), _c('a', {
    attrs: {
      "href": "https://www.nuwarobotics.com/"
    }
  }, [_vm._v("NUWA Robotics")]), _vm._v(".")]), _vm._v(" All rights reserved.\n    ")]), _vm._v(" "), _c('BackTop')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo ",
    staticStyle: {
      "width": "300px",
      "height": "42px",
      "margin-top": "20px",
      "background-color": "#3c8dbc"
    },
    attrs: {
      "src": "/static/img/back_home_img.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-language fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 text-center"
  }, [_c('h4', {
    staticStyle: {
      "margin": "0 0 0 0",
      "color": "black"
    }
  }, [_vm._v("\n                                                                tw\n                                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 text-center"
  }, [_c('h4', {
    staticStyle: {
      "margin": "0 0 0 0",
      "color": "black"
    }
  }, [_vm._v("\n                                                                en\n                                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e125a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1485
// module chunks = 1